import React from 'react';
import { Trans } from 'react-i18next';
import { Linking, TouchableOpacity } from 'react-native';

import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';

export const FraudAnalysisMessage = () => {
    return (
        <Text textAlign="center" color={ds.colorToken.text.secondary} variant="bodyMedium" mt="s8">
            <Trans i18nKey="wallet.trustly_status_fraud_analysis" ns="error">
                Security Alert: We detected some unusual activity and as a result, this transaction was not completed.
                To protect consumers and merchants, Trustly employs risk mitigation and fraud prevention tools to spot
                suspicious activity. Please see
                <TouchableOpacity onPress={() => Linking.openURL('https://us.trustly.com/business-help')}>
                    <Text lineHeight={16} textDecorationLine="underline">
                        Trustly's help center
                    </Text>
                </TouchableOpacity>
                for further information on Trustly's risk decisioning process.
            </Trans>
        </Text>
    );
};
